import React, { useMemo } from "react";
import { ConfiguratorRadioBtn } from "components/_ProductConfigurator/SubComponents/ProductConfigurationForm/ConfiguratorInputs/ConfiguratorRadioBtn";
import { ConfiguratorSelect } from "components/_ProductConfigurator/SubComponents/ProductConfigurationForm/ConfiguratorInputs/ConfiguratorSelect";
import { RangeCard } from "components/InputCards/RangeCard";
import { RangeSelectCard } from "components/InputCards/RangeSelectCard";

export const ProductConfiguratorInput = ({
  option,
  onChange,
  configuration,
  partKey,
  isModalView,
  isDisabled,
  handlePartClick,
  allowedIterablePartsSet,
}) => {
  const optionKey = `${partKey}-${option.key}`;
  const disabled =
    isDisabled ||
    option.state === 1 ||
    (allowedIterablePartsSet && allowedIterablePartsSet?.has(optionKey));

  const value = useMemo(
    () => configuration[optionKey],
    [configuration, optionKey],
  );

  if (!value) {
    return null;
  }

  if (option.range !== null) {
    // not sure how to distinguish those types of inputs, for now using signatures.length > 3 since I've found some
    // inputs where it should be the default Range input with 3 items inside the signatures
    return option.signatures?.filter((signature) => signature.state !== 2)
      .length > 3 ? (
      <RangeSelectCard
        onChange={onChange}
        label={option.title}
        description={option.description}
        signatures={option.signatures}
        value={value}
        partKey={partKey}
        optionKey={option.key}
        disabled={disabled}
        min={option.range.min}
        max={option.range.max}
      />
    ) : (
      <RangeCard
        onChange={onChange}
        label={option.title}
        description={option.description}
        value={value}
        partKey={partKey}
        optionKey={option.key}
        disabled={disabled}
        min={option.range.min}
        max={option.range.max}
      />
    );
  }

  if (option.signatures.length > 6) {
    return (
      <ConfiguratorSelect
        {...{
          option,
          onChange,
          partKey,
          value,
          disabled,
          handlePartClick,
          isModalView,
        }}
      />
    );
  }

  return (
    <>
      <ConfiguratorRadioBtn
        {...{
          option,
          onChange,
          partKey,
          value,
          disabled,
          isModalView,
        }}
      />
    </>
  );
};
